'use client'

import Link from 'next/link'

import { Icon, IconComponent } from '@graftcode/design-system'

import { quickStartNavUrlPathForSection } from '@/lib/github/tutorialSlug'
import type { TutorialSection } from '@/lib/github/types'
import { useQuickStartLanguageContext } from '@/shared/components/QuickStartLayoutShell/context/quickStartLanguageContext'
import { ACADEMY_ROUTES } from '@/shared/docs-shared.const'
import { QUICK_START_PAGE_COMPONENTS_TEST_IDS } from '@/shared/docs-test-ids.const'

import styles from '@/shared/components/DocumentationArticle/DocumentationArticle.module.scss'

type NavSection = Pick<TutorialSection, 'title' | 'path' | 'languages' | 'defaultLanguage'>

interface QuickStartNavLinksProps {
  prevSection: NavSection | null
  nextSection: NavSection | null
}

export function QuickStartNavLinks({ prevSection, nextSection }: QuickStartNavLinksProps) {
  const { selectedLanguage } = useQuickStartLanguageContext()
  const lang = selectedLanguage ?? undefined

  const prevHref = prevSection
    ? `${ACADEMY_ROUTES.quickStart}/${quickStartNavUrlPathForSection(prevSection, lang)}`
    : null

  const nextHref = nextSection
    ? `${ACADEMY_ROUTES.quickStart}/${quickStartNavUrlPathForSection(nextSection, lang)}`
    : null

  return (
    <div className={styles.navigation} data-testid={QUICK_START_PAGE_COMPONENTS_TEST_IDS.navLinks}>
      {prevHref ? (
        <Link href={prevHref} className={styles.navCard}>
          <span className={styles.navLabel}>Previous</span>
          <span className={styles.navTitleRow}>
            <IconComponent icon={Icon.ChevronLeftRegular} size={20} />
            <span className={styles.navSectionTitle}>{prevSection!.title}</span>
          </span>
        </Link>
      ) : (
        <div className={styles.navSpacer} />
      )}

      {nextHref ? (
        <Link href={nextHref} className={`${styles.navCard} ${styles.navCardNext}`}>
          <span className={styles.navLabel}>Next</span>
          <span className={styles.navTitleRow}>
            <span className={styles.navSectionTitle}>{nextSection!.title}</span>
            <IconComponent icon={Icon.ChevronRightRegular} size={20} />
          </span>
        </Link>
      ) : (
        <div className={styles.navSpacer} />
      )}
    </div>
  )
}
